import axios from "@/api/axiosInstance";
import type { ListPaymentSourcesResponse } from "./types";

export const listPaymentSources =
  async (): Promise<ListPaymentSourcesResponse> => {
    const response = await axios.get<ListPaymentSourcesResponse>(
      "/api/private/payment-sources",
    );
    return response.data;
  };
